import Branch from 'branch-sdk'

export const initBranch = (apiKey) =>
  new Promise((resolve, reject) => {
    if (!apiKey) {
      reject(new Error('apiKey cannot be empty.'))
    }
    Branch.init(process.env.REACT_APP_BRANCH_API_KEY, (err, data) => {
      if (err) {
        reject(err)
      }
      resolve(data)
    })
  })
